import React from 'react';
import { Div } from '../../../../components/grid';
import { SideMenuItem, SideMenuSpacer, SideMenuImageItem }  from '../SidemenuItems';

export default ({
  activeSidemenu,
}) => (
  <Div>
    <SideMenuItem to="/fadoelsanlaeg" title="Fadølsanlæg" active={activeSidemenu === 'Fadoelsanlaeg'} />
    <SideMenuItem to="/fadoelsbar" title="Fadølsbar" active={activeSidemenu === 'Fadoelsbar'} />
    <SideMenuItem to="/oelglas" title="Ølglas" active={activeSidemenu === 'Oelglas'} />
    <SideMenuItem to="/isterninger" title="Isterninger" active={activeSidemenu === 'Isterninger'} />
    <SideMenuItem to="/reservedele" title="Reservedele" active={activeSidemenu === 'Reservedele'} />
    <SideMenuSpacer />
    <SideMenuItem to="/fadoelsanlaeg/opsaetning-af-fadoelsanlaeg" title="Opsætning af fadølsanlæg" active={activeSidemenu === 'OpsaetningAfFadoelsanlaeg'} />
    <SideMenuItem to="/fadoelsanlaeg/tilslutning-af-fadoelsanlaeg" title="Tilslutning af fadølsanlæg, fadøl og kulsyre" active={activeSidemenu === 'TilslutningAfFadoelsanlaeg'} />
    <SideMenuItem to="/fadoelsanlaeg/vandkoelet-fadoelsanlaeg" title="Vandkølet fadølsanlæg" active={activeSidemenu === 'VandkoeletFadoelsanlaeg'} />
    <SideMenuItem to="/fadoelsanlaeg/saadan-tapper-du-den-perfekte-fadoel" title="Sådan tapper du den perfekte fadøl" active={activeSidemenu === 'SaadanTapperPerfektFadoel'} />
    <SideMenuSpacer />
    <SideMenuImageItem image="style.fadoel.png" title="Køb fadøl" to="/fadoel" />
  </Div>
);
